import { HttpAxiosRequest } from '../httpAxiosBase'

import { BaseResponse, BaseResponseWithData } from 'src/types/baseEntities'

export const HttpFiles = {
    getEndpoint: (url = ''): string => `archivos${url}`,

    // insert: (document: DocumentInsert) : Promise<BaseResponseWithData<number>> => {
    //     return HttpAxiosRequest.post(
    //         HttpFileDocument.getEndpoint(),
    //         document
    //     )
    // },

    // update: (documentId: number, document: DocumentInsert) : Promise<BaseResponseWithData<number>> => {
    //     return HttpAxiosRequest.put(
    //         HttpFileDocument.getEndpoint(`/${documentId}`),
    //         document
    //     )
    // },

    delete: (fileId: number): Promise<any> => {
        return HttpAxiosRequest.delete(HttpFiles.getEndpoint(`/${fileId}`))
    },

    // deleteFileInDocument: (documentId: number, fileId: number): Promise<any> => {
    //     return HttpAxiosRequest.delete(
    //         HttpFileDocument.getEndpoint(`/${documentId}/archivos/${fileId}`)
    //     );
    // },

    download: (fileId: number): Promise<any> => {
        return HttpAxiosRequest.getBlob(HttpFiles.getEndpoint(`/${fileId}/descargar`))
    }

    // uploadChunk: (chunk: DocumentChunkInsert) : Promise<BaseResponse> => {
    //     let formData : FormData = new FormData();

    //     formData.append(DocumentChunkFields.IdFile, chunk[DocumentChunkFields.IdFile]);
    //     formData.append(DocumentChunkFields.ChunkNumber, chunk[DocumentChunkFields.ChunkNumber].toString());
    //     formData.append(DocumentChunkFields.File, chunk[DocumentChunkFields.File], chunk[DocumentChunkFields.IdFile]);

    //     return HttpAxiosRequest.post(
    //         HttpFileDocument.getEndpoint(`/chunks/upload`),
    //         formData
    //     )
    // },

    // completeUpload: (completeUpload: DocumentChunkCompleteUpload) : Promise<BaseResponseWithData<string>> => {
    //     return HttpAxiosRequest.post(
    //         HttpFileDocument.getEndpoint(`/chunks/complete`),
    //         completeUpload
    //     )
    // },

    // getDownloadInformationChunk: (documentId: number) : Promise<DocumentDownloadInformation> => {
    //     return HttpAxiosRequest.get(
    //         HttpFileDocument.getEndpoint(`/download/${documentId}/informacion`) )
    // }
}
